import { colors } from 'components/theme';
import * as React from 'react';
import { jsx } from '@emotion/react';
import { Company } from './types';
import { AvatarItemOption, TextWrapper } from './AvatarItemOption';
import { SizeableAvatar } from './SizeableAvatar';

export type CompanyOptionProps = {
  company: Company;
  isSelected?: boolean;
  showDetails?: boolean;
};

export class CompanyOption extends React.PureComponent<CompanyOptionProps> {
  getPrimaryText = () => {
    const {
      isSelected,
      company: { name },
    } = this.props;

    const result = [
      // <TextWrapper
      //   key="name"
      //   color={isSelected ? colors.N0 : colors.N800}
      // >
          name
      // </TextWrapper>,
    ];
    return result;
  };

  renderSecondaryText = () => {
    const { company: { contactName, address }, showDetails } = this.props;
    if(!showDetails) return null;
    if (address) {
      return (
        // <TextWrapper color={colors.N200}>
        contactName || [address.line1, address.city].join(', ')

        // </TextWrapper>
      )
    }
    return null;
  };

  private renderAvatar = () => {
    const {
      company: { website, name },
      showDetails,
    } = this.props;
    const appearance = showDetails? 'big' : 'small';
    const src = website? `https://logo.accountingbox.nl?website=${website}` : '';

    return (
      <SizeableAvatar
        appearance={appearance}
        src={src}
        name={name}
      />
    );
  };

  render() {
    return (
      <AvatarItemOption
        avatar={this.renderAvatar()}
        primaryText={this.getPrimaryText()}
        secondaryText={this.renderSecondaryText()}
      />
    );
  }
}
